import {
  Main,
  Container,
  Wrapper,
  LeftColumn,
  Paragraph,
  RightColumn,
  Image,
  List,
  Link,
} from "../../globalStyles";
import market1 from "../../assets/images/market/market-1.jpg";
import market2 from "../../assets/images/market/market-2.jpg";
import market3 from "../../assets/images/market/market-3.jpg";
import gmtaMap from "../../assets/images/market/plan-gmta-2026.png";
import gmtaProgramme from "../../assets/images/market/programme-gmta-2026.png";

const Market = () => {
  return (
    <Main>
      <Container>
        <Wrapper>
          <LeftColumn>
            <h2>
              <span>Grand Marché</span>
              <br />
              <span>des Terroirs Alpins</span>
            </h2>
            <h4>L’arc alpin à Bruson!</h4>
            <Paragraph>
              <p>
                Venez voyager à travers les saveurs authentiques de nos
                montagnes ! Plus de soixante producteurs vous feront découvrir
                les spécialités et merveilles culinaires de leur région alpine.
              </p>
              <p>
                Vous y trouverez de délicieux fromages de vache, brebis et
                chèvre, en passant par des sirops, des confitures, fruits et
                légumes du terroir, ou encore de l’ail noir et des salaisons.
                Lors de votre déambulation dans le village bucolique de Bruson,
                chaque stand vous invite à une expérience gustative unique.
              </p>
              <p>
                Cette année, la cueillette des plantes sauvages est également au
                cœur de cette édition et promet de ravir toute la famille. Entre
                gourmandise et créativité, le sauvage montrera son plus tendre
                visage.
              </p>
              <p>
                Pour satisfaire vos grandes et petites faims, plusieurs espaces
                de découvertes gastronomiques titilleront vos narines et
                séduiront vos papilles tout au long du marché.
              </p>
              <p>
                À noter: un pôle spécialement dédié aux familles proposera de
                nombreux ateliers, des concerts pour enfants et des expériences
                gustatives.
              </p>
            </Paragraph>
            <Paragraph>
              <p style={{ fontStyle: "italic", color: "#ff4d6d" }}>
                Pensez à prendre du cash, il n’y a pas de distributeurs sur
                place et tous les producteurs ne disposent pas du système TWINT.
              </p>
            </Paragraph>
            <Paragraph>
              <h4>Dates</h4>
              <p>13 – 14 Juin 2026</p>
            </Paragraph>
            <Paragraph>
              <h4>Tarifs</h4>
              <p>Gratuit</p>
            </Paragraph>
            <Paragraph>
              <h4>Horaires</h4>
              <List>
                <li>Samedi: 10h00 – 22h00</li>
                <li>Dimanche: 10h00 – 17h00</li>
              </List>
            </Paragraph>
            <Paragraph>
              <h4>Transports</h4>
              <List>
                <li>Parkings: Curala, Le Châble et Valbord, Bruson</li>
                <li>
                  Navettes: Le Châble → Bruson (non stop, toutes les 15 minutes)
                  <br />
                  Samedi: 09h45 – 00h00, Dimanche: 09h45 – 19h00
                </li>
                <li>
                  Télécabines: Le Châble → Verbier (non stop)
                  <br />
                  Samedi: 05h15 – 23h50, Dimanche: 05h15 – 23h50
                </li>
              </List>
            </Paragraph>
            <Paragraph
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
              }}
            >
              <div>
                <Link href={gmtaMap} target="_blank" rel="noopener noreferrer">
                  Plan
                </Link>
                <span> et </span>
                <Link
                  href={gmtaProgramme}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  programme
                </Link>
              </div>
              <div>
                <Link
                  href="https://palpfestival.ch/evenements/le-grand-marche-des-terroirs-alpins/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Plus d'infos
                </Link>
              </div>
            </Paragraph>
          </LeftColumn>
          <RightColumn>
            <Image>
              <img src={market1} alt="Le grand marché des terroirs alpins" />
              <figcaption>© Cyril Perregaux</figcaption>
            </Image>
            <Image>
              <img src={market2} alt="Le grand marché des terroirs alpins" />
              <figcaption>© Cyril Perregaux</figcaption>
            </Image>
            <Image>
              <img src={market3} alt="Le grand marché des terroirs alpins" />
              <figcaption>© Cyril Perregaux</figcaption>
            </Image>
          </RightColumn>
        </Wrapper>
      </Container>
    </Main>
  );
};

export default Market;
